import React, { createContext, useContext, useState } from 'react'

const MyLoaderContext = createContext();


export const GlobalLoadProvider = ({children}) => {
    const [loadContext,setLoadContext]=useState(false)
  return (
    <MyLoaderContext.Provider value={{loadContext,setLoadContext}}>
        {children}
    </MyLoaderContext.Provider>
  )
}

export const useLoaderContext=()=>useContext(MyLoaderContext)

